var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439",
    transform: "translate(-948.241 -387)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 28,
    height: 27,
    rx: 13.5,
    transform: "translate(948.241 387)",
    fill: "#00ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M6.123,2.416,5.931,3.2q-.863.34-1.377.518A3.635,3.635,0,0,1,3.361,3.9a2.379,2.379,0,0,1-1.625-.51,1.648,1.648,0,0,1-.579-1.294A4.588,4.588,0,0,1,1.2,1.47q.044-.318.139-.719l.714-2.544q.1-.366.161-.693a3.065,3.065,0,0,0,.065-.6.922.922,0,0,0-.2-.68,1.131,1.131,0,0,0-.767-.192,1.99,1.99,0,0,0-.571.087q-.292.087-.5.166l.192-.784q.706-.288,1.351-.492A4.035,4.035,0,0,1,3-5.182a2.324,2.324,0,0,1,1.6.5,1.663,1.663,0,0,1,.562,1.3q0,.166-.039.584a3.952,3.952,0,0,1-.144.767L4.267.508a7.047,7.047,0,0,0-.157.7,3.7,3.7,0,0,0-.07.592.851.851,0,0,0,.227.688,1.274,1.274,0,0,0,.784.183,2.252,2.252,0,0,0,.592-.091A3.289,3.289,0,0,0,6.123,2.416ZM6.306-8.223a1.485,1.485,0,0,1-.5,1.128A1.709,1.709,0,0,1,4.6-6.628a1.724,1.724,0,0,1-1.211-.466,1.479,1.479,0,0,1-.505-1.128,1.493,1.493,0,0,1,.505-1.133A1.715,1.715,0,0,1,4.6-9.826,1.7,1.7,0,0,1,5.8-9.356,1.5,1.5,0,0,1,6.306-8.223Z",
    transform: "translate(959.024 403.015)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b807b710cd535520634042fbbecc2985.svg";
export { ForwardRef as ReactComponent };